import React from "react";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Badge, Button, Card} from "react-bootstrap";
import { CardBody } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
//import DetailsIcon from '@material-ui/icons/Details';
import UpdateIcon from '@material-ui/icons/Update';
//import DeleteIcon from '@material-ui/icons/Delete';
import {IconButton} from '@material-ui/core';
import {Tooltip} from '@material-ui/core';
import { toast } from 'react-toastify';

class FleetList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [""],fleetEdit:[],editSlot:false,remarks:"",
      partnerId: this.props.data ? this.props.data : (this.props.location.state.data ? this.props.location.state.data : '')
      ,status:""
    };
    this.nextPath = this.nextPath.bind(this);
  }

  submitHandler = () => {
    return "/partner/borewell/borewell-create"
  }

  componentDidMount() {
    const url5 = process.env.REACT_APP_NODE_ENV + "/api/fleets/getfleetbypartnerId/" + this.state.partnerId
    fetch(url5,{
      method:'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        if (!response.ok) throw new Error(response.status);
        else return response.json();
      }
    ).then(data => {
      this.setState({ Data: data });
    }).catch(error => console.log(error), this.setState({ Data: [] }))
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, state:{data: value} });
  }

  editStatusSlotHandler = value => {
    const doesToggle = this.state.editSlot;
    this.setState({ fleetEdit: value, editSlot: !doesToggle });
    this.setState({status: value.status });
  };

    handleEditFormFields = (event) => {
    //const fleetEditCopy = this.state.fleetEdit;
    switch (event.target.id) {
      case "statusUpdate":
        //fleetEditCopy.status = event.target.value;
        this.setState({ status: event.target.value});
        break;
      case "remarks":
        this.setState({remarks:event.target.value});
        break;
        default: break;
    }
  }

  save = () => {
    this.setState({ editSlot: false })
    //console.log(this.state.fleetEdit.status)
     let postFleetData = {
        id: this.state.fleetEdit.id, status: this.state.status
      };
    console.log(postFleetData);
    fetch(process.env.REACT_APP_NODE_ENV + '/api/fleets/updateFleet', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postFleetData)
    }).then((res) => {
      res.json()
      if (res.status === 406) {
        toast.error('In-Active failed, This Fleet allocated to the driver', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000

        });
        this.popUpCancel()

      }
    
    })
    .then((data) => {console.log(data);this.componentDidMount()})
    .catch((err) => console.log(err))
  };

  popUpCancel = () => {
    this.setState({editSlot:false});
  }
  
  // delete = (id) => {
  //   const postFleetData = {
  //     id: id
  //   };
  //   console.log(postFleetData);
  //   fetch('/api/fleets/delete', {
  //     method: 'DELETE',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(postFleetData)
  //   }).then(response => { if (response.ok) { this.componentDidMount() } })
  //     .then(data => console.log(data))
  //     .catch((err) => console.log(err))
  // };

  render() {

    let editSlots = null;
    if (this.state.editSlot) {
      editSlots = (
        <Modal
          isOpen={true}
          // fade={false}
          // toggle={this.to}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
      <ModalHeader> Update Status for - {this.state.fleetEdit.fleetId}</ModalHeader>
              <ModalBody>
              <><div className="col-lg-4">
            <label> <b>Status</b> </label><select  id="statusUpdate"  className="form-control" value={this.state.status} onChange={this.handleEditFormFields} >
              <option value="InActive">InActive</option>
              <option value="Active">Active</option>
          </select></div>
          <div style={{paddingTop:"20px"}} className="col-lg-8">
          <input type="text" className="form-control" id="remarks" placeholder="Remarks" value={this.state.remarks} onChange={this.handleEditFormFields} />
          </div></>
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
                </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() =>this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    let dataArr = [];
    this.state.Data.map((data) => {
      let variant = "";
      if(data.status === "InActive") {variant = "danger"}
      else {variant = "success"}
      let mdData = [
        data.fleetId, data.vehicleNumber,data.capacity,<Badge pill variant={variant}>{data.status}</Badge>,data.status,data
      ];
      dataArr.push(mdData)
      return null;
    });


    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "vehicleNo",
        label: "Vehicle Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "capacity",
        label: "Capacity",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
        }
      },
      {
        name: "status1",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          display : false
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <><Tooltip title="Details"><IconButton>
              <button onClick={() => this.nextPath("/partner/fleet/fleet-details", value.id)}>D</button> </IconButton></Tooltip>
              <Tooltip title="Update Status"><IconButton>
              <UpdateIcon onClick={() => this.editStatusSlotHandler(value)} /></IconButton></Tooltip>
              {/* <Tooltip title="Delete"><IconButton>
              <DeleteIcon onClick={() => this.delete(value.id)} /></IconButton></Tooltip> */}
              </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false
      // ,
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };



    return (
      <>
        <Card>
         <Card.Body>
         <Button className="float-right"
                    variant="outline-success"
                    style={{ marginTop: "25px", width: "150px", marginRight:"20px"}}
                    onClick={() => this.nextPath("/partner/fleet/fleet-create", this.props.data)}>
                    Add Fleet
                  </Button>
            <div style={{ marginTop: "10px" }}>
             {editSlots}
              <MUIDataTable
                title={"Fleet List"}
                data={dataArr}
                columns={columns}
                options={options} />
            </div>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default withRouter(FleetList);
